import React from "react";
import {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "./ui/dialog";
import { Button } from "./ui/button";

/**
 * Modale "En savoir plus" réutilisable.
 * S'appuie sur Radix Dialog (via components/ui/dialog) qui gère déjà
 * l'accessibilité : fermeture Échap / clic en dehors, aria-modal, piège de
 * focus et retour du focus au déclencheur à la fermeture.
 */
const InfoModal = ({
  triggerLabel = "En savoir plus",
  triggerClassName = "",
  title,
  subtitle,
  image,
  children,
}) => {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="outline" className={triggerClassName}>
          {triggerLabel}
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto bg-[#FDFBF5] border-[#DCB071]/40">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl md:text-3xl text-[#21167D] pr-6">
            {title}
          </DialogTitle>
          {subtitle && (
            <DialogDescription className="font-accent italic text-lg text-[#4A4458]">
              {subtitle}
            </DialogDescription>
          )}
        </DialogHeader>

        {image && (
          <img
            src={image.src}
            alt={image.alt}
            loading="lazy"
            className="w-full h-48 md:h-64 object-cover rounded-xl"
          />
        )}

        <div className="space-y-4 text-[#4A4458] leading-relaxed">{children}</div>
      </DialogContent>
    </Dialog>
  );
};

export default InfoModal;
